









import { defineComponent, ref, computed } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "EmailNotificationsView",
  components: { BasePage, PageTitle, BaseForm, BaseButton },
  props: {
    loading: { type: Boolean, required: true },
    value: { type: Object as () => FormValues, required: true },
  },
  setup(props, { emit }) {
    const { isCreator } = useAuthUser();
    const saving = ref(false);
    const fields = computed<FormFields>(() => [
      {
        class: "__incoming-messages",
        name: "incomingMessages",
        label: $t("Incoming messages"),
        type: "switch",
      },
      ...(config.featureGoLive
        ? [
            {
              class: "__going-live",
              name: "goingLive",
              label: $t("Going live"),
              type: "switch",
            },
          ]
        : []),
      ...(isCreator.value
        ? [
            {
              class: "__content-purchase",
              name: "contentPurchase",
              label: $t("Content purchase"),
              type: "switch",
            },
            {
              class: "__new-subscription",
              name: "newSubscription",
              label: $t("New subscription"),
              type: "switch",
            },
            ...(config.featureTippingPosts
              ? [
                  {
                    class: "__new-tip",
                    name: "newTip",
                    label: $t("New tip"),
                    type: "switch",
                  },
                ]
              : []),
            {
              class: "__message-attachment-purchase",
              name: "messageAttachmentPurchase",
              label: $t("Message attachment purchase"),
              type: "switch",
            },
          ]
        : []),
      {
        class: "__new-posts",
        name: "newPosts",
        label: $t("New Posts"),
        type: "switch",
      },
    ]);

    const onSave = () => {
      saving.value = true;
      emit("submit", () => (saving.value = false));
    };

    return { saving, fields, onSave };
  },
});
